<template>
  <div>
    <div class="createdTitle-body">
        <img src="../../assets/image/screenImg/anquan.png" alt="" class="leftTopIcon">
   <p class="createdTitle">安全管理</p>
 <screenNavigation class="screenNavigation" :name='createdName' ref="leftclick" v-clickoutside="handleClickOutside"></screenNavigation>
   </div>
  <div class="leftBody">
  <div class="left-body-title">
    <img class="jiantou" src="../../assets/image/screenImg/jt.png" alt="">
  <p class="title-txt">摄像头列表</p>
  <p class="onLineNum">在线：<span>{{onlineNum}}</span></p>
  <p class="offLineNum">离线：<span>{{offlineNum}}</span></p>

  </div>
<!-- 头部盒子下方的线条 -->
<div class='border-Max'>
<div class='border-left'>
</div>
<div class='border-center'>
</div>
<div class='border-right'>
</div>
</div>
<div class="left-bottomBody">
<div class="left-body-list"  v-for="(item, index) in tableDataEnd1" :key="index">
  <iframe
            style="width: 100%;height:100%;border: 0; "
            :src='item.showUrl'
          ></iframe>
</div>
<div class="bottom-pageList">
<p v-for="(item,index) in pageList" :key="index" class="bottom-pageList-body" :class="{numColor:index+1==pageNumA}" @click="TurnPages(index)">{{item}}</p>
</div>
</div>

  </div>
  <div class='rightBody'>
    <div class="left-body-title">
    <img class="jiantou" src="../../assets/image/screenImg/jt.png" alt="">
  <p class="title-txt">硬盘录像机列表</p>
  </div>
  <!-- 头部盒子下方的线条 -->
<div class='border-right-Max'>
<div class='border-right-left'>
</div>
<div class='border-right-center'>
</div>
<div class='border-right-right'>
</div>
</div>
<div class="righy-body-bottom" style="overflow: hidden;margin-top:0">
<div class="righy-body-bottom"  :class="{ animb: animate2 == true }">
<div class="righy-body-bottom-list" v-for="(item,index) in lifetList" :key="index" :class="{clickColor:item.id==monitorId}" >
<!-- 操作盒子· -->
     <div class="develop-show" v-if="showId==item.id"  v-clickoutside="noShowfun" >
     <p class="show-txt" @click="monitorSyn(item)">同步</p>
     <p class="show-txt" @click="encryptOffMonitor(item)">解密</p>
     </div>
   <div class="list-left" @click="changingFun(item)">
         <p class="list-name">{{ item.name }}</p>
            <p class="list-num">序列号：{{ item.serial }}</p>
   </div>
   <div class="list-right">

    <div class="develop" @click="showFun(item.id) " >
     <div v-for="(item,index) in [1,2,3]" :key="index" class="develop-list" ></div>

     
   </div>
       <p class="list-yzm">验证码：{{ item.vcode }}</p> 
     <!-- <div class="develop" @click="showFun(index) " >
     <div v-for="(item,index) in [1,2,3]" :key="index" class="develop-list" @click.stop="showFun(index)" ></div>
     <div class="develop-show" v-if="showId==index" @click="showFun(index) " >
     </div>
     
    </div>
      <p class="list-name">{{ item.name }}</p>
            <p class="list-num">序列号：{{ item.serial }}</p>
                        <p class="list-yzm">验证码：{{ item.vcode }}</p> -->
</div>
</div>

</div>
</div>
  </div>

    </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import screenNavigation from './screenNavigation.vue'
import myHttp from '../../untils/port'
  import util from '../../untils/util'
  import screenHttp from '../../untils/screenHttp'
  import base from '../../untils/base'
export default {
     directives: { Clickoutside },
  data() {
  
    return {
      onlineNum:'',
      offlineNum:'',
      createdName:'项目监控',
      animate2:false,
      showId:'id',
      pageMax:'',//总页数·
      ysToken:'',
      pageList:[],//翻页按钮数组
      pageNumA:1,
      tableDataName:'',
      monitorId:'',
      lifetList:[],
      tableDataEnd1:[],//摄像头列表
    }
  },
  components:{
screenNavigation
  },
  mounted() {
   this. getYsToken(),
    this.getSonList()
  },
  methods: {
           handleClickOutside(){
      this.$refs.leftclick.listShow=false
    
    },
    noShowfun(){
      console.log(999);
this.showId='id'

    },
    // 获取token
     getYsToken () {
      var that = this
      myHttp.getYsToken({
        projectId: util.session.get('groupId')
      }).then(function (resp) {
        if (resp.data.code == '200') {
          that.ysToken = resp.data.data.accessToken || ''
          // that.getDevice()
          // that.getData()
        }
      })
    },
    // 获取监控列表
    async getSonList () {
      var option = {
        name: this.tableDataName,
        deviceName: '',
        projectId: util.session.get('groupId')
      }
      const res = await myHttp.getMonitListByProjectId(option)

      if (res.data.code == '200') {
        console.log('成功获取左侧列表数据=========================>', res);
        this.lifetList = res.data.data.monitorList || []
  
        console.log('左侧列表数组========================》', this.lifetList);
   setInterval(this.scroll2, 2000)
      }
      this.monitorId = this.lifetList[0].id
       this.clickList()


    },
     // 获取摄像头列表
    async clickList () {

      var option = {
        pageNum: this.pageNumA,
        pageSize: 9,
        monitorId: this.monitorId,
        projectId: util.session.get('groupId')
      }
      const res = await myHttp.getListByMonitorIdNew(option)
      if (res.data.code == 200) {
        console.log('获取监控列表数据=======》', res);
        var pageMax = res.data.data.cameraList.total / 9
        console.log('总页数===================》', pageMax);
        pageMax = Math.ceil(pageMax);
        console.log('取整后的页数==========》', pageMax);
        this.pageMax = pageMax
        // this.pageList=[]
        var pageList=[]
        for (let index = 1; index <= this.pageMax; index++) {
          console.log(index,this.pageList);
        pageList.push(index)
        this.pageList=pageList
                 console.log(index,this.pageList);
        }
        console.log(this.pageList);
        var list = res.data.data.cameraList || []
        this.tableDataEnd1 = list.list
        // 循环计算出在线数和离线数
        let online=0
        let offline=0

        for (let index = 0; index < this.tableDataEnd1.length; index++) {
          const element = this.tableDataEnd1[index];
          if(element.status==1){
            // 在线数
         online=online+1
          }else if(element.status==0){
            // 
offline=offline+1
          }
          
        }
        console.log('在线设备总数-----》',online);
                console.log('离线设备总数-----》',offline);
                this.onlineNum=online
                this.offlineNum=offline
        for (var i = 0; i < this.tableDataEnd1.length; i++) {
          if (this.tableDataEnd1[i].linkType == '3') {
            if (this.tableDataEnd1[i].hardFlag == '1') {
              this.tableDataEnd1[i].showUrl = '/ie/one.html?ip=' + this.tableDataEnd1[i].monitorIp + '&port=' + this.tableDataEnd1[i].port2 + '&channel=' + this.tableDataEnd1[i].channelNo + '&username=' + this.tableDataEnd1[i].username + '&psd=' + this.tableDataEnd1[i].password
            } else {
              this.tableDataEnd1[i].showUrl = '/ie/one.html?ip=' + this.tableDataEnd1[i].ip + '&port=' + this.tableDataEnd1[i].port2 + '&channel=' + this.tableDataEnd1[i].channelNo + '&username=' + this.tableDataEnd1[i].username + '&psd=' + this.tableDataEnd1[i].password
            }
          } else {
            this.tableDataEnd1[i].showUrl = '/monitor/view/one.html?serial=' + this.tableDataEnd1[i].serial + '&channel=' + this.tableDataEnd1[i].channelNo + '&token=' + this.ysToken
          }
          this.tableDataEnd1[i].isEditName = false
        }
        console.log('摄像头列表-------',this.tableDataEnd1);
        if(this.tableDataEnd1.length==0){
          this.pageList=[]
        }
      }
    },
    // 切换摄像头列表
    changingFun(item){
      this.showId=null
this.pageNumA = 1
      this.monitorId = item.id
      this.clickList()
    },
    // 翻页处理函数
    TurnPages(index){
      this.pageNumA=index+1
      this.clickList()

    },
    showFun(id){
      console.log('监听到事件');
      this.showId=id
   
      console.log(this.showId);
    },
    // 设备解密处理函数
  async encryptOffMonitor(item){
    const data= await myHttp.encryptOffMonitor({
      projectId: util.session.get('groupId'),
serial: item.serial,
vcode: item.vcode,
    })
    if(data.data.code==200){
  console.log('cg');
      this.$message.success('解密成功')
      this.showId=null
    }else{
      console.log('sb');
       this.$message.error(data.data.msg)
             this.showId=null
    }
  },
  // 同步处理函数
   //同步
   async  monitorSyn (row) {
    const data=await myHttp.syncDeviceList({id:row.id})
    if(data.data.cede==200){
       this.$message.success('同步摄像头成功')
    }else{
       this.$message.error(data.data.msg)
    }
      // console.log(row
      // );

      //   let that = this
      //   myHttp.syncDeviceList({
      //     id: row.id
      //   }).then(function (resp) {
      //     if (resp.data.code == '200') {
      //       that.$message.success('同步摄像头成功')
      //     } else {
      //       that.$message.error(resp.data.msg)
      //     }
      //   })
        
      

  },
      scroll2(){
    if (this.lifetList.length > 12) {
      // console.log('123');
        this.animate2 = true;
        setTimeout(() => {
          this.lifetList.push(this.lifetList[0]);
          this.lifetList.shift();
          this.animate2 = false;
        }, 1200)
      } 
    },
  }

}
</script>

<style>
.leftBody{
  width: 75.4167vw;
  height:44.7917vw;
  
background: rgba(0, 35, 102, 0.2);
  margin-left: 1.25vw;
  float: left;
  margin-right:1.25vw;
  position: relative;
}
.rightBody{
  z-index:999;
  width: 20.8333vw;
  height:44.7917vw;
background: rgba(0, 35, 102, 0.2);
  float: left;

}
.left-body-title{
position: relative;
  width: 100%;
  height:2.0833vw;
  background: linear-gradient(90deg, #0B213C 0%, #0A1B35 49%, rgba(11,22,47,0.10) 100%, #0A1730 100%);

}
.jiantou{
  float: left;
  width: 2.3021vw;
  height: 1.1021vw;
  margin-top: 0.45vw;
}
.title-txt{
  
font-family: PingFang SC;
font-size: .9375vw;
font-weight: normal;
letter-spacing: 0em;
line-height: 2.0833vw;
color: #FFFFFF;
  float: left;
}
.border-Max{
  margin-top:.1042vw
}
.border-left{
  width:.3646vw;
  height:.1042vw;
  background:#518FE3;
  float:left;
  margin-right:.2083vw
}
.border-center{
  width:74.2708vw;
  height:.1042vw;
  background: linear-gradient(90deg, #11273F 0%, #608CCA 52%, #040D1F 100%);
  float:left;
    margin-right:.2083vw
}
.border-right{
  width:.3646vw;
  height:.1042vw;
  background:#518FE3;
  float:left;

}
.border-right-Max{
  margin-top:.1042vw
}
.border-right-left{
  width:.3646vw;
  height:.1042vw;
  background:#518FE3;
  float:left;
  margin-right:.2083vw
}
.border-right-center{
  width:19.6875vw;
  height:.1042vw;
  background: linear-gradient(90deg, #11273F 0%, #608CCA 52%, #040D1F 100%);
  float:left;
    margin-right:.2083vw
}
.border-right-right{
  width:.3646vw;
  height:.1042vw;
  background:#518FE3;
  float:left;

}
.left-bottomBody{
 position: absolute;
  padding-left:.8333vw;
  padding-right:.8333vw;
  width: 100%;
  height: 42.5vw;

 display: flex;
 align-content: flex-start;
 flex-flow: row wrap;
  

}
.left-body-list{
   margin-top: .8333vw;
  width: 460px;
  height: 12.8125vw;
  cursor: pointer;

  margin-right:.8333vw
}
.left-body-list:nth-child(3n){
  margin-right: 0px !important;
}
.righy-body-bottom{
  height: 41.9271vw;
  width: 100%;
  margin-top:.5208vw;
    color: rgba(255, 255, 255, 0.5);
}
.righy-body-bottom-list{

  position: relative;
  cursor: pointer;
   padding-left: .8333vw;
    padding-top: .3125vw;
  width: 20.8333vw;
  height: 2.9167vw;
  margin-bottom:.5208vw;

background: linear-gradient(270deg, rgba(79,102,131,0.00) 0%, #142A4F 52%, rgba(79,102,131,0.00) 100%);
box-sizing: border-box;
border: 1px solid ;
border-image: linear-gradient(270deg, rgba(140,180,231,0.00) 0%, #61A3F6 52%, rgba(140,180,231,0.00) 100%) 1;

}
.list-name{

 text-align: left;

 
font-family: PingFang SC;
font-size: .8333vw;
font-weight: normal;
letter-spacing: 0em;


margin-bottom: .2125vw;
}
.list-num{
 
  font-family: PingFang SC;
font-size: .7292vw;
font-weight: normal;
letter-spacing: 0em;
text-align: left;

}
.list-yzm{
   right: .2604vw;
 bottom: .1042vw;
  font-family: PingFang SC;
font-size: .7292vw;
font-weight: normal;
letter-spacing: 0em;

 position: absolute;


}
.bottom-pageList{
  align-items: center;
  justify-content: center;
  display: flex;
  width: 73.75vw;
  height: 1.208vw;

  position: absolute;
  bottom: 0;
}
.bottom-pageList-body{
  cursor: pointer;
  margin-left: .1563vw;
  margin-right:.1563vw ;
}
.numColor{
  color:#01FDFC;
}
.develop{
 
  padding-left: 2vw;
 position: absolute;
 right:  .2604vw;
 top: .1042vw;
      cursor: pointer;
  
 
}
.develop-list{
  margin-left: .0721vw;
  float: left;
  width: .1979vw;
  height: .1979vw;
  border-radius: .4042vw;
  background: #518FE3;
  margin-top: 0.3vw;
}
.develop-show{
 

position: absolute;
  top: 1.0604vw;
  right: .2604vw;
  width: 3.6458vw;
  height:3.6458vw;
  z-index:99;
 border-radius: 4px;
opacity: 1;

background: rgba(216, 216, 216, 0.01);

box-sizing: border-box;
border: 1px solid #5DCFFF;

backdrop-filter: blur(10px);
box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);

}
.list-left{
  width: 60%;
  height: 100%;

  float: left;
}
.list-right{
  position: relative;
  width: 35%;
  height: 100%;

  float: right;
}
.show-txt{
  font-family: PingFang SC;
font-size: 12px;
font-weight: normal;
letter-spacing: 0em;

color: #FFFFFF;
margin-top: .625vw;

}
.clickColor{
  color: #ffffff !important;
}
.animb{
  margin-top: -2.98vw;
  transition: all 1s;
}
.leftTopIcon{
  width: 1.8115vw;
  height: 1.8115vw;
  margin-right: .6563vw;
}
.onLineNum{
  position: absolute;
  left: 67.3438vw;
  line-height: 2.0833vw;
  font-family: PingFang SC;
font-size: .7292vw;
font-weight: normal;
letter-spacing: 0em;

color: #FFFFFF;

}
.offLineNum{
  position: absolute;
  left: 71.5104vw;
    line-height: 2.0833vw;
    font-family: PingFang SC;
font-size: .7292vw;
font-weight: normal;
letter-spacing: 0em;

color: #FFFFFF;

}
</style>
<style scoped>
 @import '../../untils/screenTop.css'
</style>